export default "__VITE_ASSET__CbQ3sFgl__"